export const EXAM_PROVINCE_CODES = [
  '10',
  '11',
  '12',
  '13',
  '14',
  '15',
  '16',
  '17',
  '18',
  '19',
  '20',
  '21',
  '22',
  '23',
  '24',
  '25',
  '26',
  '27',
  '30',
  '31',
  '32',
  '33',
  '34',
  '35',
  '36',
  '37',
  '39',
  '40',
  '41',
  '42',
  '43',
  '44',
  '45',
  '46',
  '47',
  '48',
  '49',
  '50',
  '51',
  '52',
  '53',
  '54',
  '55',
  '56',
  '57',
  '58',
  '60',
  '61',
  '62',
  '63',
  '64',
  '65',
  '66',
  '67',
  '70',
  '71',
  '72',
  '73',
  '74',
  '75',
  '76',
  '77',
  '80',
  '81',
  '82',
  '83',
  '84',
  '85',
  '86',
  '90',
  '91',
  '92',
  '93',
  '94',
  '95',
  '96',
  '97',
] as const;
